import { render, staticRenderFns } from "./CreateAttendancePage.vue?vue&type=template&id=1d96c784&"
import script from "./CreateAttendancePage.vue?vue&type=script&lang=js&"
export * from "./CreateAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports